module.exports = __webpack_public_path__ + "img/hilton.f0e0e79f.jpg";